import { render, staticRenderFns } from "./customCascaderCategory.vue?vue&type=template&id=fcd1b1c0&scoped=true&"
import script from "./customCascaderCategory.vue?vue&type=script&lang=js&"
export * from "./customCascaderCategory.vue?vue&type=script&lang=js&"
import style0 from "./customCascaderCategory.vue?vue&type=style&index=0&id=fcd1b1c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd1b1c0",
  null
  
)

export default component.exports